export default __webpack_public_path__ + "static/Vol 3 - TA 3 - CHIA (with appendices)-72de8d1fa3af774e718cb7f72c973a49.pdf";